import { render } from "./PageNavigation.vue?vue&type=template&id=4e07276a&scoped=true&ts=true"
import script from "./PageNavigation.vue?vue&type=script&lang=ts"
export * from "./PageNavigation.vue?vue&type=script&lang=ts"

import "./PageNavigation.vue?vue&type=style&index=0&id=4e07276a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src536781470/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e07276a"]])

export default __exports__